import PropTypes from 'prop-types';
import React from 'react';

import Typography from '@glass/web/components/base/Typography';

function MarkdownListItem({ children }) {
  return <Typography component="li">{children}</Typography>;
}

MarkdownListItem.propTypes = {
  children: PropTypes.node,
};

export default MarkdownListItem;
